import { IntegrationNames } from '@webapp/platform/integrations/entities/enums/IntegrationNameEnum'
import {
  buildActiveCustomFieldOptions,
  buildOrganizationalCategoryOptions,
  buildInactiveCustomFieldOptions,
  buildBillDefaultOptions,
} from './utils/getSourceMappingOptions/build-steps'
import {
  type SourceMappingPlatformConfig,
  type SourceMappingRegistry,
} from './utils/getSourceMappingOptions/types'

const quickBooksOnlineConfig: SourceMappingPlatformConfig = {
  steps: [buildOrganizationalCategoryOptions, buildActiveCustomFieldOptions],
}

const netsuiteConfig: SourceMappingPlatformConfig = {
  steps: [
    buildBillDefaultOptions,
    buildActiveCustomFieldOptions,
    buildInactiveCustomFieldOptions,
  ],
}

const sageIntacctConfig: SourceMappingPlatformConfig = {
  steps: [buildOrganizationalCategoryOptions, buildActiveCustomFieldOptions],
}

const businessCentralConfig: SourceMappingPlatformConfig = {
  steps: [buildOrganizationalCategoryOptions, buildActiveCustomFieldOptions],
}

export const sourceMappingRegistry: SourceMappingRegistry = {
  [IntegrationNames.MERGE_QUICKBOOKS_ONLINE]: quickBooksOnlineConfig,
  [IntegrationNames.MERGE_NETSUITE]: netsuiteConfig,
  [IntegrationNames.MERGE_SAGE_INTACCT]: sageIntacctConfig,
  [IntegrationNames.MERGE_BUSINESS_CENTRAL]: businessCentralConfig,
}
